module.exports = __webpack_public_path__ + "media/3.f1d90398.wav";